export default "__VITE_ASSET__BwKon3Ga__"